// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__27oiH","modalFooterButton":"ModalNotes_modalFooterButton__1bnOh"};